import { render, staticRenderFns } from "./FindingItemContent.vue?vue&type=template&id=5cca651f&scoped=true&"
import script from "./FindingItemContent.vue?vue&type=script&lang=js&"
export * from "./FindingItemContent.vue?vue&type=script&lang=js&"
import style0 from "./FindingItemContent.vue?vue&type=style&index=0&id=5cca651f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cca651f",
  null
  
)

export default component.exports